export const OPEN_FAN_KEY = 'job-vita';

const store = {
	namespaced: true,
	state: {
		show: false,
		jobProfileListItem: undefined,
		jobId: undefined,
		applicant: undefined,
		pseudonym: undefined,
		disclosedData: undefined,
		withActions: undefined,
		permissions: undefined,
		exclusionType: undefined,
		onContacted: undefined,
		onFavored: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJobProfileListItem', data.jobProfileListItem);
			commit('setJobId', data.jobId);
			commit('setApplicant', data.applicant);
			commit('setPseudonym', data.pseudonym);
			commit('setDisclosedData', data.disclosedData);
			commit('setWithActions', data.withActions);
			commit('setPermissions', data.permissions);
			commit('setExclusionType', data.exclusionType);
			commit('setOnContacted', data.onContacted);
			commit('setOnFavored', data.onFavored);

			commit('setShow', true);
		},
		close ({commit})
		{
			commit('setShow', false);

			commit('setJobProfileListItem', undefined);
			commit('setJobId', undefined);
			commit('setApplicant', undefined);
			commit('setPseudonym', undefined);
			commit('setDisclosedData', undefined);
			commit('setWithActions', undefined);
			commit('setPermissions', undefined);
			commit('setExclusionType', undefined);
			commit('setOnContacted', undefined);
			commit('setOnFavored', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setJobProfileListItem: (state, value) => state.jobProfileListItem = value,
		setJobId: (state, value) => state.jobId = value,
		setApplicant: (state, value) => state.applicant = value,
		setPseudonym: (state, value) => state.pseudonym = value,
		setDisclosedData: (state, value) => state.disclosedData = value,
		setWithActions: (state, value) => state.withActions = value,
		setPermissions: (state, value) => state.permissions = value,
		setExclusionType: (state, value) => state.exclusionType = value,
		setOnContacted: (state, value) => state.onContacted = value,
		setOnFavored: (state, value) => state.onFavored = value,
	},
};

export default store;
